import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/Favorites.css";

export default function Favorites() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    loadFavorites();
  }, []);

  const loadFavorites = async () => {
    const response = await fetch("/api/favorites", {
      credentials: "include",
    });

    if (response.ok) {
      setFavorites(await response.json());
    }
  };

  return (
    <main className="favorites-page">
      <section className="favorites-container">
        <button
          type="button"
          className="profile-back-btn"
          onClick={() => navigate("/profile")}
        >
          ← {t("favorites.backToProfile")}
        </button>

        <h1>{t("favorites.title")}</h1>

        {favorites.length === 0 ? (
          <p>{t("favorites.empty")}</p>
        ) : (
          <div className="favorites-grid">
            {favorites.map((product) => (
              <article
                key={product.productId}
                className="favorite-card"
                onClick={() =>
                  navigate(`/shop/${product.productSlug}`, {
                    state: { fromFavorites: true },
                  })
                }
              >
                {product.imageUrl && (
                  <img
                    src={product.imageUrl}
                    alt={product.productName}
                  />
                )}

                <h2>{product.productName}</h2>

                <strong>
                  {Number(product.price).toFixed(2)} €
                </strong>
              </article>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}